import { FC } from 'react';
import type { CallRecord, CallMetadata } from '@frontend/api-call-intel';
import { useModalControl } from '@frontend/design-system';
import { CallFlagsData } from '../../types';
import { CorrectionBannerConfig } from '../../utils/call-analysis-util';
import { generateTrackingId } from '../../utils/tracking';
import { EditHistoryModal } from '../modal/edit-history-modal';
import { CorrectionBanner } from './correction-banner';

interface EditBannerProps {
  isDemoAccount?: boolean;
  call: CallRecord;
  callMetadata?: CallMetadata;
  callFlags: CallFlagsData;
  isFormEdited: boolean;
  isDisabled: boolean;
  correctionBannerConfig: CorrectionBannerConfig;
  onMakeCorrection: () => void;
  onUpdateCall: (updatedFields: Partial<CallRecord>, isRestore?: boolean) => void;
}

export const EditBanner: FC<EditBannerProps> = ({
  isDemoAccount,
  correctionBannerConfig,
  call,
  callMetadata,
  callFlags,
  isDisabled,
  onMakeCorrection,
  onUpdateCall,
}) => {
  const { modalProps: editHistoryModalProps, openModal: openEditHistoryModal } = useModalControl();

  const { canMakeCorrection, isReviewed, showEditHistory } = correctionBannerConfig;

  return (
    <>
      <CorrectionBanner
        canMakeCorrection={canMakeCorrection}
        isDisabled={isDisabled}
        isReviewed={isReviewed}
        showEditHistory={showEditHistory}
        onMakeCorrection={onMakeCorrection}
        onViewEditHistory={openEditHistoryModal}
        trackingIds={{
          correctionBtn: generateTrackingId({
            component: 'call-analysis',
            context: 'make-correction-btn-click',
            isDemoAccount,
          }),
          viewHistory: generateTrackingId({
            component: 'call-analysis',
            context: 'view-edit-history-btn-click',
            isDemoAccount,
          }),
        }}
      />
      {editHistoryModalProps.show && (
        <EditHistoryModal
          modalProps={editHistoryModalProps}
          onClose={editHistoryModalProps.onClose}
          updateEditedCallInList={onUpdateCall}
          call={call}
          callMetadata={callMetadata}
          isDemoAccount={isDemoAccount}
          {...callFlags}
        />
      )}
    </>
  );
};
